export default __webpack_public_path__ + "static/media/Arrow_Simple_left1.2813e99c.svg";